import type { Follow } from '../../types/following.ts';

type RemoveFollowsWithoutPredictionsProps = {
  predictions?: Follow[];
  searchParams?: URLSearchParams;
  setSearchParams?: (params: URLSearchParams) => void;
};

const removeFollowsWithoutPredictions = ({
  predictions,
  searchParams,
  setSearchParams,
}: RemoveFollowsWithoutPredictionsProps): void => {
  if (!predictions || !searchParams || !setSearchParams) {
    return;
  }

  const followsToRemove = predictions
    .filter((prediction) => prediction.predictionsData === null)
    .map((prediction) => prediction.resultCode);

  if (followsToRemove.length > 0) {
    followsToRemove.forEach((resultCode) => {
      searchParams.delete('follows', resultCode);
    });
    setSearchParams(searchParams);
  }
};

export default removeFollowsWithoutPredictions;
